import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal } from "./Reveal";
import { FAQ_ITEMS } from "../data/faq";
import { scrollToId } from "../lib/scroll";

export const Faq = () => (
  <section id="faq" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-zinc-950 border-y border-zinc-800" data-testid="faq-section">
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-14">
      <Reveal className="lg:col-span-2">
        <p className="text-[#FF3B30] text-xs uppercase tracking-[0.35em] font-semibold mb-4">07 — FAQ</p>
        <h2 className="font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[1.02]" data-testid="faq-heading">
          Frequently<br /><span className="text-zinc-500">Asked.</span>
        </h2>
        <p className="mt-6 text-zinc-400 text-base md:text-lg max-w-md">
          Clear answers before you bring in your vehicle. Have another question? Call us or send a service request.
        </p>
        <button
          onClick={() => scrollToId("request")}
          data-testid="faq-request-btn"
          className="mt-10 bg-[#FF3B30] text-white font-oswald uppercase tracking-[0.15em] px-10 py-4 hover:bg-white hover:text-black transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
        >
          Request Service
        </button>
      </Reveal>

      <div className="lg:col-span-3">
        <Accordion type="single" collapsible className="w-full">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-zinc-800" data-testid={`faq-item-${i + 1}`}>
              <AccordionTrigger
                className="text-left font-oswald uppercase tracking-tight text-lg sm:text-xl hover:text-[#FF3B30] hover:no-underline py-5 [&>svg]:text-[#FF3B30]"
                data-testid={`faq-question-${i + 1}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-sm sm:text-base leading-relaxed whitespace-pre-line pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
